import React, { useState } from 'react';
import { Upload, QRCode , Avatar, Modal, Form, Tooltip, Button, Card,  Input, Select, Steps, Typography, Rate, Divider, Radio, InputNumber, message, Collapse, Tag } from 'antd';
import ReactPlayer from 'react-player';
import style from "./main.css"
import { Space } from 'antd';

import {
  InstagramOutlined,
  FacebookOutlined,
  LinkedinOutlined,
  TwitterOutlined,
  BookOutlined, PlayCircleOutlined, ClockCircleOutlined,
  QuestionCircleOutlined,
  CheckCircleOutlined,
  GiftOutlined,
  DollarOutlined,
  CreditCardOutlined,
  CopyOutlined,
  BankOutlined,
  InboxOutlined

} from '@ant-design/icons';


const { Panel } = Collapse;

const { Step } = Steps;
const { Title, Paragraph } = Typography;
const { Option } = Select;
const { Text } = Typography;


const socialIcons = {
  instagram: { icon: <InstagramOutlined />, color: '#E1306C' },
  facebook: { icon: <FacebookOutlined />, color: '#1877F2' },
  linkedin: { icon: <LinkedinOutlined />, color: '#0A66C2' },
  twitter: { icon: <TwitterOutlined />, color: '#1DA1F2' },
};


const CheckoutModal = ({
  visible,
  onClose,
  pricing,
  courseData,
  onApplyCoupon,
  onCheckout,
}) => {
  const {
    pricingType,
    regularPrice,
    offerPrice,
    minPrice,
    suggestedPrice,
    gstEnabled,
  } = pricing;

  const [customPrice, setCustomPrice] = useState(suggestedPrice || minPrice);
  const [coupon, setCoupon] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [finalPrice, setFinalPrice] = useState(offerPrice || regularPrice);
  const [isApplying, setIsApplying] = useState(false);

  const isUserDecide = pricingType === 'user_decide';

  const handleCouponApply = async () => {
    if (!coupon) return;
    setIsApplying(true);
    try {
      const res = await onApplyCoupon(coupon);
      if (res.valid) {
        setFinalPrice(res.discountedPrice);
        setAppliedCoupon(coupon);
        message.success('🎉 Coupon applied successfully!');
      } else {
        message.error('❌ Invalid coupon');
      }
    } catch {
      message.error('❌ Failed to validate coupon');
    } finally {
      setIsApplying(false);
    }
  };

  const handlePayment = () => {
    const amount = isUserDecide ? customPrice : finalPrice;
    onCheckout(amount, appliedCoupon);
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={<><CreditCardOutlined style={{ marginRight: 8 }} />Checkout</>}
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: '100%' }}>

        <Divider style={{ margin: '12px 0' }} />

        {isUserDecide ? (
          <>
            <Text strong>
              <DollarOutlined style={{ marginRight: 6 }} />
              Set your price
            </Text>
            <Input
              type="number"
              min={minPrice}
              value={customPrice}
              onChange={(e) => setCustomPrice(Number(e.target.value))}
              addonBefore="₹"
              style={{ marginTop: 6 }}
            />
            <Text type="secondary">
              Minimum ₹{minPrice}, Suggested ₹{suggestedPrice}
            </Text>
          </>
        ) : (
          <>
            <Text strong>
              <CreditCardOutlined style={{ marginRight: 6 }} />
              Price Details
            </Text>
            <div>
              {offerPrice && offerPrice < regularPrice ? (
                <>
                  <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                    ₹{offerPrice}
                  </Title>
                  <Text delete type="secondary">
                    ₹{regularPrice}
                  </Text>
                </>
              ) : (
                <Title level={3} style={{ margin: 0 }}>₹{regularPrice}</Title>
              )}
            </div>

            {appliedCoupon && (
              <Tag icon={<CheckCircleOutlined />} color="success">
                Coupon "{appliedCoupon}" applied
              </Tag>
            )}

            <Input.Search
              placeholder="Enter coupon code"
              enterButton="Apply"
              loading={isApplying}
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
              onSearch={handleCouponApply}
              style={{ marginTop: 10, textTransform: 'uppercase' }}
              prefix={<GiftOutlined />}
              disabled={!!appliedCoupon}
            />
          </>
        )}

        <Divider style={{ margin: '16px 0' }} />

        <Button
          type="primary"
          block
          size="large"
          onClick={handlePayment}
          icon={<CreditCardOutlined />}
        >
          Pay ₹{isUserDecide ? customPrice : finalPrice}
        </Button>
      </Space>
    </Modal>
  );
};


const AuthorsSection = ({ authors }) => {
  return (
    <div style={{ display: 'grid', gap: 32 }}>
      {authors.map((author, index) => (
        <div key={index} style={{
        boxShadow  : "0 4px 12px rgba(149, 149, 149, 0.21)",
        backgroundColor:"#ffffff",
        borderRadius: "12px",
        padding: "10px"
        }
        }>

          <div
            style={{
              width: '100%',
              height: 200,
              overflow: 'hidden',
              borderRadius: 12,
              marginBottom: 16,
            }}
          >
            <img
              src={author.imageUrl}
              alt={author.name}
              style={{ width: '100%', height: 'auto', }}
            />
          </div>

          <Text style={{ fontSize: 18, fontWeight: 700, color: '#1f1f1f', display: 'block' }}>
            {author.name}
          </Text>

          <Paragraph style={{ fontSize: 14, color: '#595959', marginTop: 4 }}>
            {author.description}
          </Paragraph>

          <Space size="large" style={{ marginTop: 8 }}>
            {Object.entries(author.socials || {}).map(([platform, link]) =>
              link ? (
                <a
                  key={platform}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: 20, color: socialIcons[platform]?.color }}
                >
                  {socialIcons[platform].icon}
                </a>
              ) : null
            )}
          </Space>
        </div>
      ))}
    </div>
  );
};


const MediaRenderer = ({ coverMedia }) => {
  const isVideo = /\.(mp4|webm|ogg)$/i.test(coverMedia); // Add formats as needed

  return isVideo ? (
    <ReactPlayer 
      url={coverMedia} 
      controls 
      width="100%" 
      height="auto"
      style={{borderRadius:"10px" }}
    />
  ) : (
    <img 
      src={coverMedia} 
      alt="cover media" 
      style={{ width: '100%', height: 'auto', borderRadius:"10px" }} 
    />
  );
};

const getCourseStats = (modules) => {
  let chapterCount = modules.length;
  let lessonCount = 0;
  let totalVideoDuration = 0;

  modules.forEach(module => {
    module.lessons.forEach(lesson => {
      lessonCount++;
      totalVideoDuration += lesson.videoDuration || 0;
    });
  });

  return { chapterCount, lessonCount, totalVideoDuration };
};

const formatDuration = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h ? `${h}h ` : ''}${m}m`;
};

const CourseStats = ({ modules }) => {
  const { chapterCount, lessonCount, totalVideoDuration } = getCourseStats(modules);

  return (
    <Space size="middle" style={{ marginTop: 8, marginBottom: 16 }}>
      <Text type="secondary" style={{ fontSize: 14 }}>
        <BookOutlined style={{ marginRight: 4 }} />
        {chapterCount} Chapters
      </Text>
      <Text type="secondary" style={{ fontSize: 14 }}>
        <PlayCircleOutlined style={{ marginRight: 4 }} />
        {lessonCount} Lessons
      </Text>
      <Text type="secondary" style={{ fontSize: 14 }}>
        <ClockCircleOutlined style={{ marginRight: 4 }} />
        {formatDuration(totalVideoDuration)}
      </Text>
    </Space>
  );
};

const TestimonialCard = ({ name, review, social, profilePicUrl }) => {

  const socialKey = social?.toLowerCase().replace("@","");
  const socialData = socialIcons[socialKey];


  return (
    <Card
      style={{
        borderRadius: 16,
        boxShadow: '0 4px 12px rgba(165, 165, 165, 0.06)',
        padding: 16,
        
        border: '1px solid rgba(165, 165, 165, 0.06)',
        marginBottom:"20px",
        width: "45%",
        maxWidth:"400px"
      }}
    >
       <div
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          fontSize: 24,
          color: socialData?.color,
          cursor: 'pointer',
        }}
      >
        {socialData?.icon}
        </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 4 }}>
        <Avatar size={48} src={profilePicUrl} />
        <div>
          <Text strong style={{ fontSize: 15 }}>{name}</Text>
          <br />
        </div>
      </div>

      <Paragraph style={{ fontSize: 15, color: '#111', lineHeight: 1.6 }}>
        {review}
      </Paragraph>
    </Card>
  );
};

const CourseContentRenderer = ({ modules }) => {
  return (
    <div style={{ marginTop: 24 }}>
      <Collapse
        accordion
        bordered={false}
        style={{ backgroundColor: '#fff', borderRadius: 12 }}
        defaultActiveKey={['0']}
      >
        {modules.map((module, moduleIndex) => (
          <Panel
            header={
              <Text style={{ fontSize: 18, fontWeight: 600, textTransform: 'capitalize'}}>
              {module.name}
              </Text>
            }
            key={moduleIndex}
            style={{
              backgroundColor: '#fafafa',
              borderRadius: 8,
              marginBottom: 12,
            }}
          >
            {module.lessons.map((lesson, lessonIndex) => {
              const lessonNumber = `${moduleIndex + 1}.${lessonIndex + 1}`;

              return (
                <div
                  key={lessonIndex}
                  style={{
                    padding: '12px 16px',
                    marginBottom: 10,
                    backgroundColor: '#f0f5ff',
                    borderRadius: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                  }}
                >
                  <Space align="center" wrap size="small">
                  
                    <Text style={{ fontSize: 18, fontWeight: 500 ,textTransform: 'capitalize'}}>
                      {lesson.name}
                    </Text>
                    {lesson.isFreePreview && (
                      <Tag color="green" style={{ fontSize: 14, borderRadius: 4 }}>
                        Free
                      </Tag>
                    )}
                  </Space>
                  <Space size="small">
                    <ClockCircleOutlined style={{ color: '#999' }} />
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      {formatDuration(lesson.videoDuration || 0)}
                    </Text>
                  </Space>
                   {lesson.isFreePreview && lesson.videoLink && (
                  <ReactPlayer
                    url={lesson.videoLink}
                    controls
                    width="100%"
                    // height="auto"
                    style={{ borderRadius: 8, marginTop: 8 }}
                  />
                )}
                </div>
              );
            })}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};



const FAQSection = ({ faqs }) => {
  return (
    <div style={{ marginTop: 32 }}>
      <Collapse
        bordered={false}
        accordion
        style={{
          backgroundColor: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        }}
      >
        {faqs.map((faq, index) => (
          <Panel
            header={<Text strong>{faq.question}</Text>}
            key={index}
            style={{
              backgroundColor: '#f9f9f9',
              borderRadius: 8,
              marginBottom: 12,
            }}
          >
            <Text style={{ fontSize: 14 }}>{faq.answer}</Text>
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};


const TypeformJoinFlow = ({fieldConfigs, setVisible}) => {
  
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [form] = Form.useForm();

  const currentField = fieldConfigs[currentStep];

  const handleNext = async () => {
    try {
      const values = await form.validateFields();
      const answer = values[currentField.label];

      // if (currentField.verifyWithOTP && !otpSent) {
      //   // Mock: send OTP here
      //   console.log(`Sending OTP to ${answer}`);
      //   setOtpSent(true);
      //   return;
      // }

      setAnswers({ ...answers, [currentField.label]: answer });
      form.resetFields();
      setOtpSent(false);

      if (currentStep + 1 < fieldConfigs.length) {
        setCurrentStep(currentStep + 1);
      } else {
        console.log('Final Answers:', { ...answers, [currentField.label]: answer });
        setVisible(false);
        setCurrentStep(0);
        setAnswers({});
      }
    } catch (err) {
      console.log('Validation failed');
    }
  };

  const renderField = () => {
    if (currentField.type === 'dropdown') {
      return (
        <Form.Item
          name={currentField.label}
          rules={[{ required: true, message: 'Please choose an option' }]}
        >
          <Select placeholder="Select an option">
            {currentField.options.map((opt) => (
              <Option key={opt} value={opt}>{opt}</Option>
            ))}
          </Select>
        </Form.Item>
      );
    } else {
      return (
        <Form.Item
          name={currentField.label}
          rules={[{ required: true, message: `Please enter ${currentField.label}` }]}
        >
          <Input
            type={currentField.type === 'number' ? 'number' : 'text'}
            placeholder={otpSent ? 'Enter OTP' : currentField.label}
          />
        </Form.Item>
      );
    }
  };

  return(
    <div>
    <Title level={4}>{currentField.label}</Title>
        <Form form={form} layout="vertical" onFinish={handleNext}>
          {renderField()}
           <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" block onClick={handleNext}>
              {otpSent ? 'Verify OTP' : 'Next'}
            </Button>
          </div>
        </Form>
    </div>
  )
};


const PaymentModal = ({ visible, onClose, courseName, amount, paymentPayload, onRazorpay, onManualConfirm }) => {
  const isUPI = paymentPayload?.type === 'wallet';
  const upiId = paymentPayload?.upi_id;
  const walletLink = paymentPayload?.wallet_link;
  const [screenshotFile, setScreenshotFile] = useState(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(upiId);
    message.success('UPI ID copied!');
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title="Complete Your Payment"
      destroyOnClose
    >
      {isUPI ? (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Title level={5}>Step 1: Scan & Pay</Title>

          <QRCode value={`upi://pay?pa=${upiId}&pn=instantdm&am=${amount}&cu=INR&tn=${courseName}`} size={160} />
          <Divider> Pay using UPI or Number </Divider>
          <Text style={{ fontSize: 16, fontWeight: 600 }}>UPI ID: <b>{upiId}</b> <CopyOutlined onClick={handleCopy} style={{ cursor: 'pointer' }} /></Text>
          <Text>Amount: ₹{amount}</Text>
          <Divider />

          <Title level={5}>Step 2: Confirm Payment</Title>
          <Text type="secondary">
            After sending the payment, click below to request manual verification.
          </Text>

          <Upload
            name="paymentScreenshot"
            listType="picture-card"
            maxCount={1}
            showUploadList={{ showRemoveIcon: true }}
            beforeUpload={() => false} // prevent auto upload
            onChange={(info) => setScreenshotFile(info.file)} // you'll need to handle this state
            style={{ marginTop: 16 }}
          >
            <div>
              <InboxOutlined style={{ fontSize: 32, color: '#999' }} />
              <div style={{ marginTop: 8 }}>Upload Screenshot</div>
            </div>
          </Upload>


          <Button
            style={{color:"white", backgroundColor:"green"}}
            icon={<CheckCircleOutlined />}
            block
            onClick={() => {
              message.success('We’ve received your confirmation. Verifying payment...');
              onManualConfirm();
            }}
            
            size='large'
          >
            I’ve Paid via UPI
          </Button>
        </Space>
      ) : (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Title level={4}>Pay ₹{amount}</Title>
          <Text>Secure payment via Razorpay</Text>
          <Button
            type="primary"
            icon={<BankOutlined />}
            block
            size="large"
            onClick={() => onRazorpay(amount)}
          >
            Pay Now
          </Button>
        </Space>
      )}
    </Modal>
  );
};



const courseData ={
  "title": "Learn react ",
  "coverMedia": "https://public-assets.instantdm.com/instantdm-shop/public/some-id/media/be93f44f-c9d4-45b2-a473-c8f6350616a3.png",
  "description": '<p>Click to add description, youtube video, link to platfrom and more.</p><p><strong>sdfsdfsdf</strong></p><p></p><p>safsdf</p><p>sdfsdf</p><p>sdfsdf</p><p>sdfs</p><p>df</p><p>sd</p><p>fsd</p><p>f</p><div data-youtube-video=""><iframe width="640" height="360" allowfullscreen="true" autoplay="false" disablekbcontrols="false" enableiframeapi="false" endtime="0" ivloadpolicy="0" loop="false" modestbranding="false" origin="" playlist="" rel="1" src="https://www.youtube.com/embed/uUdGTX2wW2g?rel=1" start="0"></iframe></div><p></p><p><a target="_blank" rel="noopener noreferrer nofollow" href="https://ant.design/components/button">https://ant.design/components/button</a></p><p></p>',
  "cta": "Join Now",
  "benefits": [
    "Benifit 1",
    "Benifit 2",
    "Benifit 3"
  ],
  "testimonials": [
    {
      "name": "ssk",
      "review": "hey this is the review, sdf sdf  sfd sd fsd f sd f sdf sd f sd fsd f sd f sd fsd f sdf ds fsd f sd f sdf sd fs df sdf sd f sdf",
      "social": "Instagram",
      "rating": 4,
      "profilePicUrl": "https://public-assets.instantdm.com/instantdm-shop/public/some-id/media/1ab60ad4-b386-47d6-a493-6cb523f1db39.png"
    },
    {
      "name": "asdasd",
      "review": "asdasdasd asd as da sd asd a sd asd as d sad as da sd asd as d asd as d asd ",
      "social": "Twitter",
      "rating": 5,
      "profilePicUrl":"https://public-assets.instantdm.com/instantdm-shop/public/some-id/media/1ab60ad4-b386-47d6-a493-6cb523f1db39.png"
    },
      {
      "name": "asdasd",
      "review": "asdasdasd",
      "social": "Twitter",
      "rating": 5,
      "profilePicUrl":"https://public-assets.instantdm.com/instantdm-shop/public/some-id/media/1ab60ad4-b386-47d6-a493-6cb523f1db39.png"
    }
    
  ],
  "faqs": [
    {
      "question": "helllo ",
      "answer": "yes, its"
    },
    {
      "question": "question 2 - asfasf sdfsdf",
      "answer": "answer goes here...sfsfaf"
    }
  ],
  "gallery": [],
  "authors": [
    {
      "name": "sdfsd",
      "description": "sdfsdfds",
      "socials": {
          facebook: undefined,
          instagram: "https://instagram.com/code_with_ssk",
          linkedin: undefined,
          twitter: undefined,
      },
      "imageUrl": "https://public-assets.instantdm.com/instantdm-shop/public/some-id/media/8b9def3d-f578-4679-b1a4-5cc33f52bc56.png"
    }
  ],
  "customSection": "",
  "themeColor": "default",
  "modules": [
    {
      "name": "chapter 1",
      "lessons": [
        {
          "name": "lesson 1",
          "videoLink": "https://www.youtube.com/watch?v=fXJ4nzZWj_E",
          "videoFile": null,
          "isFreePreview": true,
          "description": "",
          "material": null,
          videoDuration:40
        },
        {
          "name": "lesson 2",
          "videoLink": "",
          "videoFile": null,
          "isFreePreview": false,
          "description": "",
          "material": null,
          videoDuration:50
        }
      ]
    },
    {
      "name": "chapter 2",
      "lessons": [
        {
          "name": "lesson 2",
          "videoLink": "https://www.youtube.com/watch?v=fXJ4nzZWj_E",
          "videoFile": null,
          "isFreePreview": true,
          "description": "",
          "material": null
        }
      ]
    }
  ],
  "validity": {
    "type": "lifetime",
    "limitValue": 1,
    "limitUnit": "months"
  },
  "pricing": {
    "pricingType": "fixed",
    "regularPrice": 10000,
    "offerPrice": 8000,
    "gstEnabled": false,
    "minPrice": 200,
    "suggestedPrice": 500
  },
  "fields": [
    {
      "label": "Mobile",
      "type": "number",
      "isDefault": true,
      "verifyWithOTP": true
    },
    {
      "label": "Email",
      "type": "text",
      "isDefault": true,
      "verifyWithOTP": true
    },
    {
      "label": "Full Name",
      "type": "text",
      "isDefault": true
    },
    {
      "label": "choose 1",
      "type": "dropdown",
      "options": [
        "opt 1",
        "opt 2",
        "opt 3"
      ],
      "isDefault": false
    }
  ],
  "coupons": [
    {
      "code": "SAVE 20",
      "type": "percent",
      "value": 10
    }
  ],
  "policies": {
    "terms": "sdfsdf sdf sf sf s fs df sd fs f sdf sd fsdf sdfsds s sdfsdfsdf",
    "refund": "sdfsdf  sdfsdf s sdfsdf",
    "privacy": "sdfs sdf sfdsd fsdf sdf sdf sdf sf"
  }
}


const CoursePurchaseFlow = () => {
  const [step, setStep] = useState(0);
  const [form] = Form.useForm();

  const [checkoutVisible, setCheckoutVisible] = useState(false)

  const handleFinish = (values) => {
    console.log('User Data:', values);
    message.success('Info collected! Proceeding to payment.');
    setStep(2);
  };

    let payment_payload = {
      "type":"wallet", // or rzpay
      "upi_id":"9626777690@upi",
      "wallet_link":"upi://pay?pa={upi_id}&pn={name}&am={amount}&cu=INR&tn={course_name}",
      "rzpy_public":""
    }


  const [visible, setVisible] = useState(false);

  return (
    <div className={`main-content ${visible ? 'blur-overlay' : ''}`}  style={{ maxWidth: 600, margin: 'auto', marginBottom:"40px" , padding: 24, backgroundColor:"white", minHeight:"100vh"}}>
        <div className='header'><h3 style={{textAlign:"center"}}>{courseData.title}</h3></div>
        <MediaRenderer coverMedia={courseData.coverMedia} />

        <h2>{courseData.title}</h2>
        <CourseStats modules={courseData.modules}/>
        <h2>Course Benefits 🎉</h2>
        {
          courseData.benefits.map((item) => <p style={{fontSize:"18px"}}>✅{item}</p>)
        }
        <Divider/>

        <h2>Description</h2>
        <div dangerouslySetInnerHTML={{__html:courseData.description.replace('iframe width="640"', 'iframe width="100%"')}}/>
        <Divider />

        <h2>Chapters & More</h2>
        <CourseContentRenderer modules={courseData.modules} />
        <h2>Reviews</h2>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            // justifyContent: 'fle',
          }}
        >
        {courseData.testimonials.map((t, i) => (
          <TestimonialCard
            key={i}
            name={t.name}
            review={t.review}
            social={`@${t.social}`}
            profilePicUrl={t.profilePicUrl}
          />
        ))}
        </div>
        <h2>About Author</h2>
        <AuthorsSection authors={courseData.authors}  />
        
        <h2>Common Questions</h2>
        <FAQSection faqs={courseData.faqs} />

        <Button 
         style={{
          position: 'fixed',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          maxWidth: 600,
          width: '90%',
          zIndex: 1000,
        }}
        onClick={() => setCheckoutVisible(true)}
        // onClick={() => setVisible(true)}
        color={courseData.themeColor} variant="solid" className='sticky-btn' block size='large'>{courseData.cta || "Join Now"}</Button>
        
    {/* <CheckoutModal
    
    visible={checkoutVisible}
    onClose={() => setCheckoutVisible(false)}
    pricing = {courseData.pricing}
    onApplyCoupon={async (code) => {
    const res = await fetch(`/api/coupon?code=${code}`);
    return await res.json();
  }}
  onCheckout={(amount, couponCode) => {
    console.log('Proceed to pay', amount, 'Coupon:', couponCode);
  }}

    /> */}

      <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        closable={false}
        destroyOnClose
        title={`Register ${courseData.title}`}
      >
        <TypeformJoinFlow fieldConfigs={courseData.fields} setVisible={setVisible} />
      </Modal>

      <PaymentModal
      
      visible={checkoutVisible}
      onClose={() => setCheckoutVisible(false)}
      amount = {courseData.pricing.offerPrice}
      courseName={courseData.title}
      paymentPayload={payment_payload}
      onRazorpay={() => {console.log("payment razorpay")}}
      onManualConfirm={() => {console.log("on manual confirm")}}
      />
    </div>
  );
};

export default CoursePurchaseFlow;